import { Component, OnInit } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';
import { Serviceprovider } from '../../classes/serviceprovider.interface';
import { MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { ProceedtochatComponent } from '../../pulse/proceedtochat/proceedtochat.component';
import { CommonService } from '../../services/common.service';
import { RazorpayService } from '../../PaymentGateway/razorpay/razorpay.service';
import * as moment from 'moment';
import { MapdirectionComponent } from '../../pulse/mapdirection/mapdirection.component';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Router } from '@angular/router';
import { PleasewaitComponent } from '../../pulse/pleasewait/pleasewait.component';
import { ShowalertComponent } from '../../pulse/showalert/showalert.component';
import { ShowservicesComponent } from '../../pulse/showservices/showservices.component';
@Component({
  selector: 'app-docschat',
  templateUrl: './docschat.component.html',
  styleUrls: ['./docschat.component.css'],
})
export class DocschatComponent implements OnInit, OnDestroy {
  did: any;
  chattype: string;
  mitterchannel: any;
  nowtime: any;
  service: any;
  public loading: any;
  doctor: any
  selectedOption: string;
  timer: any;
  counter = 4;
  uid: any;
  docid: any;
  uname: any;
  uemail: any;
  umobile: any;
  amount: any;
  private paymentstatus: any;
  private paymentid: any;
  servertime: any;
  stime: any;
  etime: any;
  speci: any;
  lat: any;
  lon: any;
  currentLocation: any;
  services: any;
  servicemunus = [];
  p= 1;
  action: any;
  notavailable = [];
  ipadd: any;
  source: any;
  special: any;
  constructor(private doctorservice: DoctorService, public dialog: MatDialog , private commonService:
  CommonService, private razorpayService: RazorpayService,
  private  snackbar: MatSnackBar, private router: Router) {
    window.scrollTo(0, 0);
    this.loading = false;
    this.timer = setInterval(() => this.timedelay(), 1000);
    this.razorpayService.paymentstatus.subscribe(ps => {
      this.paymentstatus = ps;
      if (this.paymentstatus === 1) {
        this.nextAction();

      }
    });
   // this.commonService.pulsemenuflagstatus.next(1);
   this.commonService.setPulseMenuFlag(1);
    this.commonService.specializationfilterid.subscribe((x) => {
      this.speci = x;
      if(this.speci != 0){
        this.getspecialist(this.speci);
      }
    });
    this.commonService.lat.subscribe((x) => {
      this.lat = x;
    });
    this.commonService.lon.subscribe((x) => {
      this.lon = x;
    });
    this.commonService.geosetflagvalue.subscribe((x) => {
      const gsfvalue = x;
      if (gsfvalue == 1) {
        this.getNewPosition();
      }
    });
    this.commonService.getIpAddress()
    .subscribe(
      (x) => {
        this.ipadd = x.ip;
      });
      this.source = 'WebApp';
   }

  ngOnInit() {
    this.loading = true;
    this.getChatDetails();
    this.getServiceProvider();
    this.doctorservice.getAllServicess()
    .subscribe(
      (x) => {
        this.services = x;
      });

  }
  getNewPosition() {
    this.currentLocation = {'lat': this.lat, 'lon': this.lon};
  }
  timedelay() {
    this.counter = this.counter  - 1;
    if (this.counter === 0) {
      const udata = this.commonService.getUserDataLocally();
      this.uid = udata.uid;
      this.uname = udata .uname;
      this.uemail = udata.uemail;
      this.umobile = udata.umobile;
      clearInterval(this.timer);
      this.loading = false;
    }
  }
  getChatDetails() {
    this.doctorservice.getChatDetail()
    .subscribe(
      (m) => {
        this.service = m;
      } );
  }
  getServiceProvider() {
    this.doctorservice.getDoctors()
    .subscribe(
      (x) => {
        this.doctor = x;
        for (let i = 0; i < this.doctor.length; i++) {
          this.getServicesForDoctor(this.doctor[i].id);
          this.checkFirstTimeAvailablity(this.doctor[i].user_id)
         }
      });
    }

    getServicesForDoctor(sid) {
      this.doctorservice.getServiceMenus(sid)
      .subscribe( (x) => {
        const temp = x;
        if ( temp && temp.length > 0) {
          for (let i = 0 ; i < temp.length ; i++) {
            if (temp[i].service_id == 37 || temp[i].service_id == 38) {
              this.servicemunus.push(temp[i]);
            }

          }
        }
      });
    }
  
    checkOnline(id, docuid) {
      this.getNowTime();
     // this.getChatDetails();
      this.loading = true;
      this.doctorservice.checkDoctorAvailablity(id)
      .subscribe(
        (x) => {
          if (x.length > 0) {
            this.checkAlreadyBookedAtThisMoment(docuid)
          } else {
            this.loading = false;
            alert('We are very Sorry Doctor has Go offline At this Moment. Please try With Another doctor')
          }
        });
    }
    getNowTime() {
      this.doctorservice.getTime()
      .subscribe(
        (d) => {
          const ctime = d.date;
          const css = moment(ctime.date);
          const cs =  moment.utc(css);
          this.nowtime = moment(cs, 'MM-DD-YYYY hh:mm:ss').unix() * 1000;
        });
    }
    checkAlreadyBookedAtThisMoment(docuid) {
      this.commonService.doctorScheduledChatAtThisTime(docuid)
      .subscribe(
        (x) => {
          if (x.length == 0) {
            this.checkAlreadyOnGoingChatAtThisMoment(docuid)
          }else {
            this.loading = false;
            alert('This Doctor is busy scheduled with others at this moment.please try after some time');
          }
        });
    }
    checkAlreadyOnGoingChatAtThisMoment(docuid) {
      this.commonService.doctorOnoingChatAtThisTime(docuid)
      .subscribe(
        (x) => {
          if (x.length == 0) {
            this.loading = false;
            this.openDialog(docuid)
          } else {
            this.loading = false;
            alert('This Doctor is busy in another chat please try after some time or Try Another Service provider');
          }
        });
    }
    openDialog(docid) {
      this.docid = docid;
      this.getServiceproviderId(this.docid);
      const dialogRef = this.dialog.open(ProceedtochatComponent, {
        width: '500px',
        height: '500px',
        data: {id: this.docid },
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result){
          if ( result[0].data1 === 'text') {
            this.amount = result[0].data2;
            this.chattype = 'text';
           // this.openRazorpay();
            this.openDialog2();
          } else if (result[0].data1 === 'video') {
            this.amount = result[0].data2;
            this.chattype = 'video';
          //  this.openRazorpay();
           this.openDialog2();
          }
        }
        

    });
    }


    getServiceproviderId(did){
      this.doctorservice.getServiceproviderId(did)
      .subscribe((x)=>{
        this.did = x[0].id;
      });
    }
    openDialog2(){
      const dialogRef = this.dialog.open(PleasewaitComponent, {
        width: '700px',
        height: '700px',
        data: {id: this.uid, did: this.did},
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(status => {
        if (status) {
          this.openAlert(status);
        }
    });
    }
    openAlert(status){
      if(status === "Doctor is busy"){
        const dialogRef = this.dialog.open(ShowalertComponent, {
          width: '300px',
          height: '300px',
          data: {data1: "Doctor is busy"}
        });
        dialogRef.afterClosed().subscribe(s => {
      });
       } else if(status === "Not Answered"){
        const dialogRef = this.dialog.open(ShowalertComponent, {
          width: '300px',
          height: '300px',
          data: {data1: "Doctor is busy. Please try another doctor."}
        });
        dialogRef.afterClosed().subscribe(s => {
      });

       } else if(status === "Rejected"){
        const dialogRef = this.dialog.open(ShowalertComponent, {
          width: '300px',
          height: '300px',
          data: {data1: "Doctor has rejected your request. Please try another doctor."}
          
        });
        dialogRef.afterClosed().subscribe(s => {
      });
   
       } else {
        const dialogRef = this.dialog.open(ShowalertComponent, {
          width: '300px',
          height: '300px',
          data: {data1: "Doctor has accepted your request. Please proceed for payment"},
          disableClose: true
        });
        dialogRef.afterClosed().subscribe(s => {
          if (s === 'Accepted') {
            this.openRazorpay();
          }
       });
    }
  }

    openRazorpay() {
      var type = 'chat';
      this.razorpayService.createtransaction(this.uname, this.uemail, this.umobile, this.amount, this.uid, type)
    }
    private nextAction() {
      this.paymentid = this.razorpayService.getPaymentId();
      if(this.paymentid !== undefined){
        const order_id = 'chat';
        const order_type = 'onlinechatchat'
        this.razorpayService.initiateTransaction(this.uid, this.paymentid, this.amount, order_id,
        order_type )
        .subscribe(
          (x) => {
            this.getTime()
          });
      } else {
        this.loading = true;
        this.razorpayService.managestatus.next(0);
        this.loading = false;
        this.openSnackBar('Chat Booking Successfully');
        this.router.navigate(['/chats']);
      }
  
    }
    getTime() {
      this.doctorservice.getTime()
      .subscribe(
        (d) => {
          const ctime = d.date;
          const css = moment(ctime.date);
          const cs =  moment.utc(css);
          this.servertime = moment(cs, 'MM-DD-YYYY hh:mm:ss').unix() * 1000;
          this.stime = this.servertime ;
          this.etime = this.stime + (900 * 1000);

          this.initiateChatWithMitter();
        });
    }
    initiateChatWithMitter() {
    this.loading = true;
     this.commonService.createNewChannel(this.docid, this.uid , this.stime, this.etime)
      .subscribe(
        (x) => {
          this.mitterchannel = x;
          this.createChatWithUs()
        });
    }
    createChatWithUs() {
      const date = moment(this.stime).format('MM/DD/YYYY');
      this.stime =  moment(this.stime).format('hh:mma');
      this.etime =  moment(this.etime).format('hh:mma');
      const status = 'Complete';
      if (this.ipadd === undefined) {
        this.ipadd = '0.0.0.0' ;
      }
      this.commonService.createChatWithUs(this.uid, this.docid, date, this.stime, this.etime,
      this.chattype, this.amount, status, this.mitterchannel.mitterChannelId , this.ipadd , this.source)
      .subscribe(
        (x) => {
          this.razorpayService.managestatus.next(0);
          this.loading = false;
          this.openSnackBar('Chat Booking Successfully');
          this.router.navigate(['/chats'])
        });
    }
    openSnackBar(msg) {
      this.snackbar.open(msg , this.action, {
        duration: 4000,
      });
     }
    getDirection(lat, lon) {
      const dialogRef = this.dialog.open( MapdirectionComponent, {
        width: '600px',
        height: '600px',
        data: {'lat': lat, 'lon': lon , 'lato': this.lat, 'lono': this.lon}
      });
    }
    checkFirstTimeAvailablity(uid) {
      this.commonService.doctorScheduledChatAtThisTime(uid)
      .subscribe(
        (x) => {
          if (x.length > 0) {
            this.notavailable.push(uid);
          } else {
           this.checkSecondTimeAvailablity(uid);
          }
        });
    }
    checkSecondTimeAvailablity(uid) {
      this.commonService.doctorOnoingChatAtThisTime(uid)
      .subscribe(
        (y) => {
          if (y.length > 0) {
           this.notavailable.push(uid);
          }
        });
    }
    checkAvailablitywithmitter(uid) {
      let count = 0;
      for (let i = 0; i < this.notavailable.length ; i ++) {
        if (this.notavailable[i] === uid) {
          count ++;
        }
      }
      return count;
    }
    getspecialist(spid) {
      this.loading = true;
      this.doctorservice.getSpecialist(spid)
      .subscribe(
        (x) => {
          this.special = x;
          this.loading = false;
        });
     }
    ngOnDestroy() {
      this.commonService.setPulseMenuFlag(0);
    //  this.commonService.pulsemenuflagstatus.next(0);
      this.commonService.specialisationfilter.next(0);
      this.commonService.latitude.next(0.0);
      this.commonService.longitude.next(0.0);
      this.commonService.doctornameflag.next('na');
    }
    showServices(id) {
      const dialogRef = this.dialog.open( ShowservicesComponent, {
        width: '500px',
        height: '500px',
        data: {'id': id}
      });
    }

  }



